// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#040f42","menuText":"#95a1c1","menuActiveText":"#fff"};